import React from "react";
import { Link as RouterLink } from "react-router-dom";

export const articles = [
  {
    title:
      "The $3 Billion Loss Year: End-of-Year Security Report",
    description:
      "2025 made it unmistakably clear: in Web3, security is no longer a background concern or merely a checkbox; it is the defining factor separating the projects that survived from the ones that collapsed.",
    readTime: "12 min read",
    date: "Dec 31, 2025",
    tags: ["Article", "Security", "Solidity", "EVM", "Move", "Audit"],
    path: "/articles/eoy-security-report-2025",
  },
  {
    title:
      "Scaling the Adversarial Mindset: How We're Using AI and Knowledge Graphs for Pre-emptive Security",
    description:
      "In our last article, we argued that the most critical protocol vulnerabilities lie not in simple code errors, but in flawed business logic, broken economic assumptions, and unsafe composability.",
    readTime: "10 min read",
    date: "Dec 1, 2025",
    tags: ["Article", "Security", "AI", "Knowledge Graph", "Phishing"],
    path: "/articles/scaling-adversarial-mindset",
  },
  {
    title:
      "Beyond the Code - Advanced Human-Led Techniques in DeFi Security Auditing",
    description:
      "This is the second article in our series on protocol security. In Article 1: The 3 Subtle Bugs We Found, we showed you real-world examples of critical bugs we've uncovered. Now, we'll explain the expert-led methodology we use to find them.",
    readTime: "12 min read",
    date: "Nov 24, 2025",
    tags: ["Article", "Audit", "Security", "EVM", "Solidity", "Case Study"],
    path: "/articles/beyond-the-code",
  },
  {
    title:
      "The 3 Most Subtle Solidity Bugs We Found in Audits (And How We Found Them)",
    description:
      "Three real audit case studies showing how business-logic flaws and adversarial thinking uncover vulnerabilities automated tools miss.",
    readTime: "11 min read",
    date: "Nov 19, 2025",
    tags: ["Article", "Audit", "Security", "EVM", "Solidity", "Case Study"],
    path: "/articles/most-subtle-solidity-bugs-from-audits",
  },
  {
    title:
      "The Human Weakness in a Decentralised World: Phishing Attacks and Social Engineering in Web3",
    description:
      "Blockchain security is a critical aspect of Web3, but it's not foolproof. Phishing attacks and social engineering tactics can still compromise even the most secure systems.",
    readTime: "9 min read",
    date: "Oct 7, 2025",
    tags: ["Blockchain", "Security", "Smart Contracts"],
    path: "/articles/phishing-attacks-and-social-engineering-in-web3",
  },
];

const Blog = () => {
  return (
    <section
      id="blog"
      className="blog-page pb-5 bg-light"
      style={{ paddingTop: "8rem" }}
    >
      <div className="container">
        <div className="text-center mb-5 section-header">
          <h2 className="section-title">
            <span>Security Blog</span>
          </h2>
          <p
            className="section-subtitle lead text-muted mx-auto"
            style={{ maxWidth: "700px" }}
          >
            Security-focused articles dissecting hacks, design flaws, and how to
            build more resilient protocols
          </p>
        </div>

        <div className="row">
          {articles.map((article) => (
            <div className="col-md-6 mb-4" key={article.title}>
              <div className="card h-100 border-0 shadow">
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{article.title}</h5>
                  <p className="card-text flex-grow-1">{article.description}</p>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <small className="text-muted">{article.readTime}</small>
                    <small className="text-muted">{article.date}</small>
                  </div>
                  <div className="mb-3">
                    {article.tags.map((tag) => (
                      <span className="badge badge-secondary mr-2" key={tag}>
                        {tag}
                      </span>
                    ))}
                  </div>
                  <RouterLink
                    to={article.path}
                    className="btn btn-primary btn-sm align-self-start"
                  >
                    Read article
                  </RouterLink>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
